import React, { useState } from "react";
import { getAuth, updatePassword } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import "./index.css";

function ChangePasswordModal() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    setError("");

    if (newPassword !== confirmPassword) {
      return setError("❌ Passwords do not match.");
    }

    if (newPassword.length < 6) {
      return setError("❌ Password must be at least 6 characters.");
    }

    setLoading(true);
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      // ✅ Update password
      await updatePassword(user, newPassword);

      // ✅ Clear mustChangePassword flag in Firestore
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        mustChangePassword: false,
      });

      setSuccess(true);

      // ✅ Reload the app so AuthContext reinitializes
      setTimeout(() => {
        window.location.reload(); // 🎯 Reload everything
      }, 1000);
    } catch (err) {
      setError("⚠️ " + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ padding: "2rem", maxWidth: 400 }}>
        <h2>🔒 Set a New Password</h2>
        <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
          You're required to set a new password before continuing.
        </p>

        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="modal-input"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="modal-input"
          style={{ marginTop: "0.5rem" }}
        />

        {error && <p style={{ color: "red", marginTop: "0.5rem" }}>{error}</p>}
        {success && <p style={{ color: "green", marginTop: "0.5rem" }}>✅ Password updated!</p>}

        <button
          onClick={handleUpdate}
          disabled={loading}
          className="modal-button"
          style={{ marginTop: "1rem" }}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
